import common from 'store/modules/common/api'

export const api = {
  ...common.softDeleteApiMethods('BottlesSimple'),
  quickSell: (soldByChannel, bottleIds) => common.httpClient.post(`/api/services/app/BottlesSimple/QuickSell`, { soldByChannel, bottleIds }, common.options()).then(r => common.processResponse(r)),
}
